import http from 'services/http'
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES_NAME } from 'constants/trans'
import i18n from './i18n'

const Trans = {
  get names() {
    return SUPPORTED_LANGUAGES_NAME
  },
  get defaultLanguage() {
    return DEFAULT_LANGUAGE
  },
  get supportedLanguages() {
    return SUPPORTED_LANGUAGES
  },
  get currentLanguage() {
    return i18n.locale
  },
  set currentLanguage(lang) {
    i18n.locale = lang
  },
  /**
   * Checks if a lang is supported
   * @param {String} lang
   * @return {boolean}
   */
  isLangSupported(lang) {
    return Trans.supportedLanguages.includes(lang)
  },
  /**
   * Checks if the route's param is supported, if not, redirects to the first supported one.
   * @param {Route} to
   */
  async checkLang(to) {
    const { lang } = to.params;
    const i18nLocale = lang || 'en';

    if(i18nLocale && i18n.locale !== i18nLocale && Trans.isLangSupported(i18nLocale)) {
      await Trans.setLanguage(i18nLocale)
    }
    return true;
  },
  async setLanguage(locale) {
    
    if (i18n.locale !== locale) {
      const messages = await Trans.loadLocaleMessages(locale);
      i18n.setLocaleMessage(locale, messages);
      i18n.locale = locale;
    }
  },
  async loadLocaleMessages(locale) {
    if(!isServer) {
      return await import(`../langs/${locale}.json`);
    } else {
      return await require(`../langs/${locale}.json`)
    }
  }
}

export default Trans